import { Avatar, Badge, Box, Center, Checkbox, Flex, Grid, GridItem, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList, Spinner, Text, Tooltip } from "@chakra-ui/react"
import MyDiv from "./managementIntractionList.style"
import { ArrowRightIcon, ChevronDownIcon, ViewIcon } from "@chakra-ui/icons"
import CustomTables, { Column, ILazyParams, } from "../../../../components/CustomTable/CustomTables";
// import { FiArrowRight, FiUserX } from "react-icons/fi"

const ManagementIntractionList = ({ teamList, loading, selectedEmployees, toggleAll, toggleRow, getRowKey, handleshowMember, onMoveTeam, onRemoveRole, query = {
    lazyParams: { first: 0, rows: 20, page: 0, sortField: "", sortOrder: 1, filters: {}, multiSortMeta: [], },
}, setQuery, totalCount = 0, }: any) => {

    const tableLazyParams: ILazyParams = {
        first: query.lazyParams.first ?? 0,
        rows: query.lazyParams.rows ?? 20,
        sortField: query.lazyParams.sortField || undefined,
        sortOrder: query.lazyParams.sortOrder ?? 1,
        multiSortMeta: query.lazyParams.multiSortMeta ?? [],
        filters: query.lazyParams.filters ?? {},
        globalFilter: "",
    };

    const handleLazyChange = (p: ILazyParams) => {
        const filtersChanged =
            JSON.stringify(p.filters ?? {}) !==
            JSON.stringify(query.lazyParams.filters ?? {});

        setQuery((prev: any) => {
            const first = filtersChanged ? 0 : (p.first ?? 0);
            const rows = p.rows ?? prev.lazyParams.rows ?? 20;

            return {
                ...prev,
                lazyParams: {
                    ...prev.lazyParams,
                    first,
                    rows,
                    page: Math.floor(first / rows),
                    sortField: p.sortField ?? "",
                    sortOrder: p.sortOrder ?? 1,
                    filters: p.filters ?? {},
                },
            };
        });
    };
    return (
        <MyDiv>
            <Box>
                <Grid className='grid_container' columnGap={4}>
                    <GridItem colSpan={12}>
                        <Box position="relative" minH="350px">
                            <Box className="table_wrapper" mt={2}>
                                <CustomTables<any>
                                    value={teamList}
                                    loading={loading}
                                    emptyMessage="No Team Interaction Data Available"
                                    preferenceKey="managementInteraction"
                                    showGlobalSearch={false}
                                    showToolbar
                                    lazy
                                    lazyParams={tableLazyParams}
                                    onLazyParamsChange={handleLazyChange}
                                    totalRecords={totalCount}
                                    showPagination
                                    rowsPerPageOptions={[20, 30, 90, 210]}
                                    maxTableHeight={null}
                                >
                                    <Column header={
                                        <Checkbox colorScheme="green" isChecked={
                                            teamList.length > 0 &&
                                            teamList.every((emp: any) =>
                                                selectedEmployees.some(
                                                    (s: any) => getRowKey(s) === getRowKey(emp)
                                                )
                                            )
                                        }
                                            isIndeterminate={
                                                teamList.some((emp: any) =>
                                                    selectedEmployees.some(
                                                        (s: any) => getRowKey(s) === getRowKey(emp)
                                                    )
                                                ) &&
                                                !teamList.every((emp: any) =>
                                                    selectedEmployees.some(
                                                        (s: any) => getRowKey(s) === getRowKey(emp)
                                                    )
                                                )
                                            }
                                            onChange={toggleAll}
                                        />
                                    }
                                        body={(row: any) => (
                                            <Checkbox colorScheme="green" isChecked={selectedEmployees.some(
                                                (e: any) => getRowKey(e) === getRowKey(row)
                                            )}
                                                onChange={() => toggleRow(row)}
                                            />
                                        )}
                                    />
                                    {/* 
                                   <Column header="S. No" body={(_, index) => query.lazyParams.first + index + 1} /> */}
                                    <Column header="Employee" field="name" sortable filterable filterType="text"
                                        body={(row: any) => (
                                            <Flex align="center" gap={2.5} minW="0" width="100%">
                                                <Avatar size="sm" name={row.name} bg="#006838" color="white" flexShrink={0} />

                                                <Box flex="1" minW="0">
                                                    <Text fontSize="13px" fontWeight="600" color="#0F172A" whiteSpace="normal" overflowWrap="anywhere"
                                                    >
                                                        {row.name || "-"}
                                                    </Text>

                                                    <Text fontSize="11px" color="#94A3B8" whiteSpace="normal" overflowWrap="anywhere"
                                                    >
                                                        {row.email || "-"}
                                                    </Text>
                                                </Box>
                                            </Flex>
                                        )}
                                    />

                                    <Column field="phone" header="Phone" />
                                    <Column field="branch" header="Branch" sortable filterable filterType="text" />
                                    <Column field="department" header="Department" sortable filterable filterType="text" />
                                    <Column field="designation" header="Designation" sortable filterable filterType="text" />

                                    <Column
                                        header="Role"
                                        body={(row: any) => (
                                            <Badge borderRadius="full" px={2.5} py={0.5} fontSize="11px"
                                                bg={row.role === "Manager" ? "#EFF6FF" : "#F0FDF4"}
                                                color={row.role === "Manager" ? "#2563EB" : "#15803D"}
                                            >
                                                {row.role}
                                            </Badge>
                                        )}
                                    />

                                    <Column header="Team Size" body={(row: any) => (
                                        <Text fontSize="13px" color="#374151">
                                            {(row.teamMembers || []).length}
                                        </Text>
                                    )}
                                    />

                                    <Column header={
                                            <Text textAlign="center" fontSize="sm" fontWeight="500">
                                                Actions
                                            </Text>
                                        }
                                        body={(emp: any) => (
                                            <HStack spacing={1} justify="center">
                                                <Tooltip label="View Team Members" hasArrow>
                                                    <IconButton aria-label="View" icon={<ViewIcon />} size="sm" variant="ghost"
                                                        colorScheme="green"
                                                        onClick={() => handleshowMember(emp)}
                                                    />
                                                </Tooltip>

                                                <Menu placement="bottom-end">
                                                    <MenuButton
                                                        as={IconButton}
                                                        aria-label="More"
                                                        icon={<ChevronDownIcon />}
                                                        size="sm"
                                                        variant="ghost"
                                                    />
                                                    <MenuList fontSize="13px">
                                                        <MenuItem
                                                            icon={<ArrowRightIcon />}
                                                            isDisabled={(emp.teamMembers || []).length === 0}
                                                            onClick={() => onMoveTeam(emp)}
                                                        >
                                                            Move whole team
                                                        </MenuItem>
                                                        <MenuItem
                                                            color="#DC2626"
                                                            onClick={() => onRemoveRole(emp)}
                                                        >
                                                            Remove {emp.role} role
                                                        </MenuItem>
                                                    </MenuList>
                                                </Menu>
                                            </HStack>
                                        )}
                                    />
                                </CustomTables>
                            </Box>
                        </Box>
                    </GridItem>
                </Grid>
            </Box>
        </MyDiv>
    )
}

export default ManagementIntractionList